import { render, staticRenderFns } from "./SubmitterFields.vue?vue&type=template&id=07a62b7c&scoped=true&"
import script from "./SubmitterFields.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubmitterFields.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a62b7c",
  null
  
)

export default component.exports